import React from "react";
import PropTypes from "prop-types";
import { Switch, Redirect, Route } from "react-router-dom";

import SoloAnnotateView from "features/solo/annotate/components/AnnotateView";
import SoloUploadView from "features/solo/upload/components/UploadView";
import SoloConfirmView from "features/solo/confirm/components/ConfirmView";
import NotFound from "components/404";

const SoloRouter = props => (
  <Switch>
    <Redirect
      exact
      from={`${props.match.url}/`}
      to={`${props.match.url}/upload`}
    />
    <Route path={`${props.match.url}/upload`} component={SoloUploadView} />
    <Route path={`${props.match.url}/annotate`} component={SoloAnnotateView} />
    <Route path={`${props.match.url}/confirm`} component={SoloConfirmView} />
    <Route component={NotFound} />
  </Switch>
);

SoloRouter.propTypes = {
  match: PropTypes.shape({
    url: PropTypes.string.isRequired
  }).isRequired
};

export default SoloRouter;
